import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import filtrosGlobais from "./filtrosglobais.module";
import projetos from "./projetos.module";
import empresas from "./empresas.module";
import emitentes from "./emitentes.module";
import fluxosDeCaixa from "./fluxosdecaixa.module";
import planosFinanceiros from "./planosfinanceiros.module";
import centrosDeResponsabilidade from "./centrosderesponsabilidade.module";
import portadores from "./portadores.module";
import produtos from "./produtos.module";
import tiposDeMulta from "./tiposdemulta.module";
import naturezasDeOperacao from "./naturezasdeoperacao.module";
import profissoes from "./profissoes.module";
import configuracoes from "./configuracoes.module";
import transacoesProgramadas from "./transacoesprogramadas.module";

import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";
import profile from "./profile.module";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        filtrosGlobais,
        projetos,
        empresas,
        emitentes,
        fluxosDeCaixa,
        planosFinanceiros,
        centrosDeResponsabilidade,
        portadores,
        produtos,
        tiposDeMulta,
        naturezasDeOperacao,
        profissoes,
        configuracoes,
        transacoesProgramadas,
        htmlClass,
        config,
        breadcrumbs,
        profile
    }
});